// document.getElementById('select-activity').value = null;
// const select = document.getElementById("select-activity").selectedIndex;
$(document).on('load', '#select-activity', function () {
    console.log('Test');
});
$(document).on('change', '#select-activity', function () {
    const selectValue = document.getElementById("select-activity").value;
    const afterSelect = document.getElementById("select-activity").selectedIndex;
    const inputSubject = document.getElementById('subject').value;
    const inputMessage = document.getElementById('message').value;

    if (afterSelect !== 0) {
        if (select === undefined || select !== afterSelect) {
            const subject = $(this).find(':selected').data('subject');
            const message = $(this).find(':selected').data('message');

            if (inputSubject.length === 0 && inputMessage.length === 0) {
                document.getElementById('subject').value = subject ?? '';
                document.getElementById('message').value = message ?? '';
            } else {
                confirm('Are you sure you want to overwrite subject and message?', function () {
                    document.getElementById('subject').value = subject ?? '';
                    document.getElementById('message').value = message ?? '';
                }, function () {
                    document.getElementById('select-activity').value = selectValue;
                });
            }
        }
        let select = afterSelect;
    } else {
        if (inputSubject.length !== 0 || inputMessage.length !== 0) {
            confirm('Are you sure you want to remove the subject and message?', function () {
                document.getElementById('subject').value = '';
                document.getElementById('message').value = '';
            })
        }
    }
})
